export const formatNumberToK = (number: number): string => {
  if (number >= 1000) {
    // Convert to thousands and keep one decimal place
    const thousands = (number / 1000).toFixed(1);
    // Remove .0 if the decimal is zero
    const formatted = thousands.endsWith('.0')
      ? thousands.slice(0, -2)
      : thousands;

    return `${formatted}K`;
  }

  return number.toString();
};

// Usage examples:
// formatNumberToK(10000) → "10k"
// formatNumberToK(15500) → "15.5k"
// formatNumberToK(900) → "900"
// formatNumberToK(1000) → "1k"
